


























import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { IContactRecordTypeInput } from '@/modules/Contact/interfaces/contact-form'

@Component({
  components: {
    AppTextSearch
  }
})
export default class ContactFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IContactRecordTypeInput }) value!: IContactRecordTypeInput

  mounted () {
    this.getRecordTypes(RecordTypeMaster.CONTACT)
  }

  recentlyClickHandler (index: number) {
    const recordType = this.recentlyUsedRecordTypes[index]
    this.candidateRecordTypes.push()
    const findIndex = this.candidateRecordTypes.findIndex(rt => rt.name === recordType.name)
    if (findIndex === -1) {
      this.candidateRecordTypes = [...this.candidateRecordTypes, recordType]
    }
    this.value.recordType = {
      name: recordType.name,
      id: +recordType.id
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
